import React from 'react';
import './navHome.css'
import logo from './logo.svg'
import nav from './navScript'


export const NavHome = () => {
  return <><nav id='navHome' className='navHome'>
    <a href="#navHome"><div className="hamBurger" onClick={nav.hamBurger}>
      <div className="bar1"></div>
      <div className="bar2"></div>
      <div className="bar3"></div>
    </div></a>
    <span className="mbLogo"><img src={logo} alt="logo"/></span>
    <ul>
      <li>About Us</li>
      <li>Products</li>
      <li>Team</li>
      <li className="navLogo" ><img src={logo} alt="logo"/></li>
      <li>Blogs</li>
      <li>Investors</li>
      <li>Contact Us</li>
    </ul>
  </nav>
  <div className="navSpace"></div>
  </>;
};
